import React, { FC } from 'react';
import styles from './index.module.css';

import { GuestInvite } from './manage_access/guest_invite';
import { Button } from 'antd';
import HelpArticleButton from 'appJS/utils/HelpArticleButton';

interface Props {
  shareLink: string;
  isGuest: boolean | undefined;
  handleCancel: () => void;
  isShareDeliverable: boolean;
}

export const ShareDeliverables: FC<Props> = props => {
  const { shareLink, isGuest, handleCancel, isShareDeliverable } = props;

  const handleClickUsersPage = event => {
    handleCancel();
    event.preventDefault();
    event.stopPropagation();
    window.share_project_props.openModal(isGuest ? 'guest' : 'member');
  };

  return (
    <div className={styles.shareDeliverables}>
      <div className={styles.leftModal}>
        <GuestInvite
          shareLink={shareLink}
          isShareDeliverable={isShareDeliverable}
        />
        {!isGuest && (
          <Button
            className={styles.inviteButton}
            type="link"
            onClick={e => handleClickUsersPage(e)}
          >
            Want to invite your Team? Click here
          </Button>
        )}
      </div>
      {!isGuest && (
        <div className={styles.rightModal}>
          <HelpArticleButton articleId={11424306} />
          <h3>What's this like for my client?</h3>
          <iframe
            src="https://player.vimeo.com/video/1057731736?h=d37700eaf1&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
            title="Watch this quick explainer (30 sec)"
          />
          <p className={styles.small}>Watch this quick explainer (30 sec)</p>
        </div>
      )}
    </div>
  );
};
